import Kpis from "../filters/Kpis";
import Dimensions from "../filters/Dimensions";
import React from "react";
import { Col, Row } from "antd";
import PeriodDatesPickerContainer from "../../PeriodDatesPickerContainer";
import GlobalKpiView from "../Global/GlobalKpiView";
import MonoBarView from "./../Global/MonoBarView";
import { FormattedMessage } from "react-intl";
import MultiGlobalKpiView from "../Global/MultiGlobalKpiView";
import MultiDimensionsView from "../Global/MultiDimensionsView";
import { getSummaryKpiSelected, getTableLoading } from "../../../selectors";
import { connect } from "react-redux";
import Export from "../Export";
import ExtraStats from "../ExtraStats";

const Global = props => {
  const data = props.data || {};
  const brandsData = data.brands || {};
  const kpi = props.kpi || {};
  const title = kpi && kpi.long_label ? props.kpi.long_label : "";
  const kpiNotPercent = kpi.format === "Pourcentage" || kpi.format_input === "percentage" ? "" : "p-pdg-0";
  const displayBrands = kpi.source && (kpi.source.toLowerCase() === "product" || kpi.source.toLowerCase() === "brand");
  const brandsBlockClass = displayBrands ? "p-w-3-5" : "p-w-100";

  return (
    <div className="p-stats">
      <div className="p-stats-content">
        <div className="p-al-full p-stats-dashboard-container-top">
          <div style={{ overflow: "hidden", width: "230px" }}>
            <div className="p-mrg-bot-s p-al-c-center">
              <PeriodDatesPickerContainer />
            </div>
            <div
              className={`p-content-item p-stats-dashboard-item ${kpiNotPercent}`}
              style={{ height: "calc(100% - 42px)", overflow: "hidden" }}
            >
              <GlobalKpiView title={title} />
            </div>
          </div>
          <div
            className="p-content-item p-stats-dashboard-item p-scroll-x"
            id="monobar"
            style={{ width: "calc(100% - 240px" }}
          >
            <MonoBarView
              title={
                <FormattedMessage id={"ENSEIGNES"} defaultMessage={"ENSEIGNES"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
              //kpi={kpi}
              //data={retailersData}
              //loading={props.graphLoading}
            />
          </div>
        </div>
        <div className="p-al-full p-stats-dashboard-container-bot">
          <div className={`${brandsBlockClass} p-content-item p-stats-dashboard-item p-scroll-y`} id="multidim">
            <MultiDimensionsView
              title={
                <FormattedMessage id={"SECTEURS"} defaultMessage={"SECTEURS"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
            />
          </div>
          {displayBrands && (
            <div className="p-w-2-5 p-content-item p-stats-dashboard-item p-scroll-y">
              <MultiGlobalKpiView
                title={
                  <FormattedMessage id={"MARQUES"} defaultMessage={"MARQUES"}>
                    {txt => <React.Fragment>{txt}</React.Fragment>}
                  </FormattedMessage>
                }
                kpi={kpi}
                data={brandsData}
                loading={props.graphLoading}
              />
            </div>
          )}
        </div>
        <Row gutter={16} style={{ marginTop: 10 }}>
          <Col offset={8} span={4}>
            <ExtraStats />
          </Col>
          <Col span={4}>
            <Export />
          </Col>
          <Col span={4}>
            <Kpis />
          </Col>
          <Col span={4}>
            <Dimensions displayMaxOrder={0} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

//REDUX
const mapStateToProps = state => {
  return {
    loading: getTableLoading(state),
    kpi: getSummaryKpiSelected(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Global);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/views/Global.js